/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pain.reducer';

export const PainDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const painEntity = useAppSelector(state => state.pain.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="painDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pain.detail.title">Pain</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pain.id">Id</Translate>
            </span>
          </dt>
          <dd>{painEntity.id}</dd>
          <dt>
            <span id="cramps">
              <Translate contentKey="tinyMedicRestApp.pain.cramps">Cramps</Translate>
            </span>
          </dt>
          <dd>{painEntity.cramps ? 'true' : 'false'}</dd>
          <dt>
            <span id="crampLevel">
              <Translate contentKey="tinyMedicRestApp.pain.crampLevel">Cramp Level</Translate>
            </span>
          </dt>
          <dd>{painEntity.crampLevel}</dd>
          <dt>
            <span id="ovulationPain">
              <Translate contentKey="tinyMedicRestApp.pain.ovulationPain">Ovulation Pain</Translate>
            </span>
          </dt>
          <dd>{painEntity.ovulationPain ? 'true' : 'false'}</dd>
          <dt>
            <span id="opLevel">
              <Translate contentKey="tinyMedicRestApp.pain.opLevel">Op Level</Translate>
            </span>
          </dt>
          <dd>{painEntity.opLevel}</dd>
          <dt>
            <span id="headache">
              <Translate contentKey="tinyMedicRestApp.pain.headache">Headache</Translate>
            </span>
          </dt>
          <dd>{painEntity.headache ? 'true' : 'false'}</dd>
          <dt>
            <span id="headacheLevel">
              <Translate contentKey="tinyMedicRestApp.pain.headacheLevel">Headache Level</Translate>
            </span>
          </dt>
          <dd>{painEntity.headacheLevel}</dd>
          <dt>
            <span id="backache">
              <Translate contentKey="tinyMedicRestApp.pain.backache">Backache</Translate>
            </span>
          </dt>
          <dd>{painEntity.backache ? 'true' : 'false'}</dd>
          <dt>
            <span id="backacheLevel">
              <Translate contentKey="tinyMedicRestApp.pain.backacheLevel">Backache Level</Translate>
            </span>
          </dt>
          <dd>{painEntity.backacheLevel}</dd>
          <dt>
            <span id="nausea">
              <Translate contentKey="tinyMedicRestApp.pain.nausea">Nausea</Translate>
            </span>
          </dt>
          <dd>{painEntity.nausea ? 'true' : 'false'}</dd>
          <dt>
            <span id="nauseaLevel">
              <Translate contentKey="tinyMedicRestApp.pain.nauseaLevel">Nausea Level</Translate>
            </span>
          </dt>
          <dd>{painEntity.nauseaLevel}</dd>
          <dt>
            <span id="tenderBreasts">
              <Translate contentKey="tinyMedicRestApp.pain.tenderBreasts">Tender Breasts</Translate>
            </span>
          </dt>
          <dd>{painEntity.tenderBreasts ? 'true' : 'false'}</dd>
          <dt>
            <span id="migraine">
              <Translate contentKey="tinyMedicRestApp.pain.migraine">Migraine</Translate>
            </span>
          </dt>
          <dd>{painEntity.migraine ? 'true' : 'false'}</dd>
          <dt>
            <span id="migraneLevel">
              <Translate contentKey="tinyMedicRestApp.pain.migraneLevel">Migrane Level</Translate>
            </span>
          </dt>
          <dd>{painEntity.migraneLevel}</dd>
          <dt>
            <span id="other">
              <Translate contentKey="tinyMedicRestApp.pain.other">Other</Translate>
            </span>
          </dt>
          <dd>{painEntity.other ? 'true' : 'false'}</dd>
          <dt>
            <span id="comments">
              <Translate contentKey="tinyMedicRestApp.pain.comments">Comments</Translate>
            </span>
          </dt>
          <dd>{painEntity.comments}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pain.active">Active</Translate>
            </span>
          </dt>
          <dd>{painEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.pain.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{painEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pain.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{painEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pain.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{painEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pain.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{painEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.pain.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{painEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pain.cycleDay">Cycle Day</Translate>
          </dt>
          <dd>{painEntity.cycleDay ? painEntity.cycleDay.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pain" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pain/${painEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PainDetail;
